export default class StatisticUtils {
  static checkNullAndPrettifyNumber(number) {
    if (number == null) {
      return '';
    }
    number = parseFloat(number);
    if (isNaN(number)) {
      return '';
    }
    return number.toLocaleString(undefined, {maximumFractionDigits: 2})
  }

}